import { useEffect, useRef } from "react";
import { api } from "../lib/api.js";

/**
 * Who is signed in, and the way out. Signing out ends the session on the server; the app then
 * re-checks and shows the sign-in page. The top bar owns `open`, like the other bar panels.
 */
export default function AccountMenu({ user, open, setOpen }) {
  const boxRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = e => {
      if (!boxRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = e => {
      if (e.key !== "Escape") return;
      e.stopPropagation();
      setOpen(false);
      btnRef.current?.focus();
    };
    document.addEventListener("pointerdown", onDown);
    window.addEventListener("keydown", onKey, true);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      window.removeEventListener("keydown", onKey, true);
    };
  }, [open, setOpen]);

  const signOut = async () => {
    try {
      await api.signOut();
    } finally {
      setOpen(false);
      window.dispatchEvent(new Event("pot:signed-out"));
    }
  };

  return (
    <div className="app-acct-box" ref={boxRef}>
      <button
        ref={btnRef}
        type="button"
        className="app-btn app-acct"
        aria-expanded={open}
        aria-controls="app-acct-panel"
        aria-label={`Account: ${user.email}`}
        onClick={() => setOpen(!open)}
      >
        <span className="app-avatar" aria-hidden="true">
          {(user.name || user.email).charAt(0).toUpperCase()}
        </span>
      </button>
      {open && (
        <section className="app-acct-panel" id="app-acct-panel" aria-label="Account">
          <p className="app-acct-email">{user.email}</p>
          <p className="app-acct-role">{user.role === "owner" ? "Owner" : "Member"}</p>
          <button type="button" className="app-acct-out" onClick={signOut}>
            Sign out
          </button>
        </section>
      )}
    </div>
  );
}
